var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_c('header',[_c('CommonHeader')],1),_vm._m(0),_c('footer',[_c('CommonFooter')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contents"},[_c('div',{staticClass:"message"},[_c('p',[_vm._v("404 Not Found.")]),_c('p',[_vm._v("ページが存在しません")])])])
}]

export { render, staticRenderFns }